// extracted by mini-css-extract-plugin
export default {"messageContainer":"Chat_messageContainer__Z2ZTX"};